/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

export const GET_CALCULATOR_FORM_DATA_RESPONSE = {
	cpuModels: [
		{
			model: "Intel Xeon",
			cores: 6
		}
	],
	cloudProviders: ["Amazon Web Service", "Google Cloud Platform", "Azure"]
};

export const GET_ON_PREMISE_OPTIONS_RESPONSE = {
	areas: [
		{
			name: "Europe",
			regions: ["Italy", "Germany", "France", "Denmark"]
		},
		{
			name: "Asia",
			regions: ["India", "China", "Japan", "Taiwan"]
		}
	],
	gpuModels: ["Marca ABC", "AMD EFG"],
	cpuModels: [
		{
			model: "Core i7-8700B",
			cores: 6
		},
		{
			model: "EPYC 7452",
			cores: 32
		},
		{
			model: "EPYC 7551",
			cores: 32
		}
	]
};

export const GET_CLOUD_PROVIDER_OPTIONS_RESPONSE = {
	areas: [
		{
			name: "Europe",
			regions: ["europe-north-1", "europe-west1", "europe-west2", "europe-west3"]
		},
		{
			name: "Asia",
			regions: ["asia-northeast1", "asia-east1", "asia-east2", "asia-east3"]
		}
	],
	cpuModels: [
		{
			model: "Core i7-8700B",
			cores: 6
		},
		{
			model: "EPYC 7452",
			cores: 32
		},
		{
			model: "EPYC 7551",
			cores: 32
		}
	]
};

export const START_CALCULATOR_RESPONSE = {
	co2: 13.37,
	emissionUnit: "gCo2e",
	power: 3.73,
	powerUsedUnit: "kWh",
	treeEq: 0.07,
	carEq: 30,
	planeEq: 20,
	cpuEmission: 60,
	memoryEmission: 30,
	gpuEmission: 5,
	storageEmission: 5,
	calculatorSimulations: [
		{
			countryName: "Italy",
			co2Emission: 10.3,
			emissionUnit: "gCo2e"
		},
		{
			countryName: "France",
			co2Emission: 30.3,
			emissionUnit: "gCo2e"
		},
		{
			countryName: "Germany",
			co2Emission: 20.3,
			emissionUnit: "gCo2e"
		}
	]
};
